import Vue from 'vue';

export default {
    namespaced: true,
    // -----------------------------------------------------------------
    state: {
        codes: [],
    },
    // -----------------------------------------------------------------
    getters: {
        all: (state) => {
            return state.codes.map(item => {
                return {
                    ...item, ...{
                        total_amount: item.amount * item.available,
                        selected: false
                    }
                }
            })
        },
    },
    // -----------------------------------------------------------------
    mutations: {
        SET_CODES(state, codes) {
            state.codes = codes
        },
        PUSH_CODES(state, codes) {
            state.codes = state.codes.concat(codes)
        },
    },
    // -----------------------------------------------------------------
    actions: {
        readCodes: (context, data) => {
            return Vue.api.get('discount-codes', { params: data })
                .then(response => {
                    context.commit((data.page === 1) ? 'SET_CODES' : 'PUSH_CODES', response.data.data)
                    return response.data
                })
                .catch(error => { throw error.response.data.error })
        },
        readCode: (context, id) => {
            return Vue.api.get(`discount-codes/${id}`)
                .then(response => {
                    return response.data.data
                })
                .catch(error => { throw error.response.data.error })
        },
        createCode: (context, data) => {
            return Vue.api.post(`discount-codes`, data)
                .then(response => {
                    return response.data.data
                })
                .catch(error => { throw error.response.data.error })
        },
        generateCodes: (context, data) => {
            return Vue.api.post(`unique-discount-codes`, data)
                .then(response => {
                    return response.data.data
                })
                .catch(error => { throw error.response.data.error })
        },
        generateEmailCodes: (context, data) => {
            return Vue.api.post(`unique-email-discount-codes`, data)
                .then(response => {
                    return response.data.data
                })
                .catch(error => { throw error.response.data.error })
        },
        generatePatternCodes: (context, data) => {
            return Vue.api.post(`pattern-discount-codes`, data)
                .then(response => {
                    return response.data.data
                })
                .catch(error => { throw error.response.data.error })
        },
        updateCode: (context, data) => {
            return Vue.api.put(`discount-codes/${data.id}`, data)
                .then(response => {
                    return response.data.data
                })
                .catch(error => { throw error.response.data.error })
        },
    }
}
